import { styled } from '@clickcease/cc-client-components-lib'

export const MetaParamsTabStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const MetaParamsNotice = styled('div', {
  background: '#FFFBE6',
  border: '1px solid #FFE58F',
  boxShadow: '0px 0px 30px rgba(102, 102, 102, 0.05)',
  borderRadius: '8px',
  width: 'calc(100% - 18px)',
  padding: '$4',
  marginTop: '16px',
  display: 'flex',
  color: '$warning',
  alignItems: 'center',

  ['> svg']: {
    padding: '$4',
    width: '16px',
    height: '16px',
  },
})

export const MetaParamsText = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  flex: 1,
})

export const ToAddTracking = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  margin: '20px 0px',
})

export const StepsList = styled('ul', {
  fontWeight: '$l',
  fontSize: '$md',
  padding: '0px 0px 0px 24px',
  margin: '0px',
})

export const Step = styled('li', {})

export const StepTwoText = styled('div', {
  marginBottom: '12px',
})
export const StepThreeText = styled('div', {
  margin: '12px 0px',
})
